import { SVGProps } from 'react'

export const CounterMinusIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="10rem" height="1rem" viewBox="0 0 10 1" fill="none" {...props}>
      <path
        d="M0 0H9.17857V0.714286H0V0Z"
        fill="url(#paint0_linear_3827_18541)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3827_18541"
          x1="8.51317"
          y1="-10.5175"
          x2="-9.06716"
          y2="-0.31008"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#4F4F4F" />
        </linearGradient>
      </defs>
    </svg>
  )
}
